









































































import Vue, { PropType } from 'vue';
// import booth, { BoothData, Pickup } from '@/modules/exhibitor/booth';
// import { Item } from '@/modules/exhibitor/item';
//
// import { options } from 'mostra';
import {
  options,
  Item,
  booth,
  BoothData,
  Pickup,
} from 'mostra';
// import { options } from '@/modules/options';
// import { itemCategories } from '@/modules/options';

interface DataType {
  categoryOptions: object[];
  isPickupModalOpen: boolean;
  pickupItemOptions: Item[];
  selectedPickupIds: string[];
  currentIndex: number;
  listLength: number;
  maxDisplayedItemLength: number;
  pagerLength: number;
  maxPagerLength: number;
  listItems: Item[];
  pagerItems: number[];
}

export default Vue.extend({
  name: 'GBoothPickupForm',
  props: {
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    booth: {
      type: Object as PropType<BoothData>,
      required: true,
    },
    items: {
      type: Array as PropType<Item[]>,
      required: true,
    },
  },
  data(): DataType {
    return {
      categoryOptions: [{ text: '全てのカテゴリ', value: 0 }, ...options.itemCategories],
      isPickupModalOpen: false,
      // MEMO 商品選択で選んだ商品 ピックアップはこの中から選ぶ
      pickupItemOptions: [],
      // MEMO 選択中のピックアップ商品ID 初期状態および選択されている全ての商品のID
      selectedPickupIds: [],
      currentIndex: 1,
      listLength: 0,
      maxDisplayedItemLength: 30,
      pagerLength: 0,
      maxPagerLength: 8,
      listItems: [],
      pagerItems: [],
    };
  },
  watch: {
    'booth.items'() {
      this.setPickupItemOptions();
      this.filterSelectedItems();
    },
    pickupItemOptions(array: any) {
      if (array) {
        this.listLength = array.length;
        this.pagerLength = Math.ceil(array.length / this.maxDisplayedItemLength);
        this.createList(this.currentIndex);
      }
    },
    currentIndex(index: number) {
      this.createList(index);
    },
  },
  methods: {
    getItem(id: string): Item {
      const it = this.items.find((item) => item.id === id);
      if (!it) {
        throw Error(`filtered itmes by ${id}`);
      }
      return it;
      // if (!filteredItem) return;
      // this.item = filteredItem.data;
      // this.name = this.item.base.name;
      // this.itemNumber = this.item.base.itemNumber;
    },
    // async fetchItems() {
    //   try {
    //     this.loading = true;
    //     // const uid = this.$auth.uid;
    //     this.items = await item.loadsByOwner(this.$auth.cid);
    //   } catch (error: any) {
    //     console.log(error);
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    setPickupItemOptions() {
      const selectedItemIds = this.booth.items;
      this.pickupItemOptions = this.items.filter(({ id }) => id && selectedItemIds.includes(id));
      this.listItems = this.pickupItemOptions;
    },
    filterSelectedItems() {
      this.selectedPickupIds = this.booth.pickups.map((pickup: Pickup) => pickup.itemId);
    },
    // MEMO モーダルでの商品選択完了時に商品の選択状態によりthis.booth.pcikupsに追加・削除をする。
    onSelectPickupDone() {
      const currentPickupsId = this.booth.pickups.map((pickup: Pickup) => pickup.itemId);
      const currentPickups = this.booth.pickups.filter((pickup: Pickup) => this.selectedPickupIds.includes(pickup.itemId));
      const newPickupId = this.selectedPickupIds.filter((id) => !currentPickupsId.includes(id));
      const newPickups = newPickupId.map((id) => booth.createNewPickup(id));
      this.booth.pickups = [...currentPickups, ...newPickups];
      this.filterSelectedItems();
      this.isPickupModalOpen = false;
    },
    onClickDeletePickup(targetId: string) {
      return () => {
        // MEMO boothデータから削除
        this.booth.pickups = this.booth.pickups.filter(
          (pickup: Pickup) => pickup.itemId !== targetId,
        );
        // MEMO 選択中のピックアップから削除（モーダル表示用）
        this.selectedPickupIds = this.selectedPickupIds.filter((id) => id !== targetId);
      };
    },
    onSwapPickupPosition(mode: 'up' | 'down', targetIndex: number) {
      return () => {
        let swapTargetIndex = 0;
        if (mode === 'up') {
          if (targetIndex === 0) return;
          swapTargetIndex = targetIndex - 1;
        }
        if (mode === 'down') {
          if (targetIndex === this.booth.pickups.length - 1) return;
          swapTargetIndex = targetIndex + 1;
        }
        const copiedPickups = [...this.booth.pickups];
        copiedPickups[swapTargetIndex] = this.booth.pickups[targetIndex];
        copiedPickups[targetIndex] = this.booth.pickups[swapTargetIndex];
        this.booth.pickups = copiedPickups;
      };
    },
    opnePickupModal() {
      this.filterSelectedItems();
      this.isPickupModalOpen = true;
    },
    closePickupModal() {
      this.isPickupModalOpen = false;
    },
    onCategoryChange(val: number) {
      const selectedItemIds = this.booth.items;
      if (!val) {
        this.pickupItemOptions = this.items.filter(({ id }) => id && selectedItemIds.includes(id));
      } else {
        const selectedItems = this.items.filter(({ id }) => id && selectedItemIds.includes(id));
        this.pickupItemOptions = selectedItems.filter((itemValue: Item) => val === itemValue.data.category.categoryId);
      }
      this.listItems = this.pickupItemOptions;
      this.currentIndex = 1;
    },
    createList(index: number) {
      const startIndex = (index - 1) * this.maxDisplayedItemLength;
      this.listItems = [];
      for (let i = 0; i < this.maxDisplayedItemLength; i++) {
        if (!this.pickupItemOptions[startIndex + i]) break;
        this.listItems.push(this.pickupItemOptions[startIndex + i]);
      }
    },
    setPagerItems(list: number[]) {
      this.pagerItems = list;
    },
    prevPage() {
      if (this.currentIndex <= 1) return;
      this.currentIndex--;
    },
    changePage(index: number) {
      this.currentIndex = index;
    },
    nextPage() {
      if (this.currentIndex >= this.pagerLength) return;
      this.currentIndex++;
    },
  },
  mounted() {
    this.setPickupItemOptions();
    this.filterSelectedItems();
  },
});
